import type { ResponsiveValue } from 'styled-system';

import type { GridItemProps, GridProps } from '../extensions';
import { grid, gridItem } from '../extensions';
import styledFactory from '../styledFactory';
import variantFactory from '../variantFactory';

export interface Props extends GridProps, GridItemProps {
  variant?: ResponsiveValue<string>;
  __gridCommon__?: 'common';
}

/**
 * A convenience component for grid layouts.
 */
const Grid = styledFactory<Props, 'div'>(
  'div',
  'Grid',
  [
    variantFactory('components.grid', { prop: '__gridCommon__' }),
    variantFactory('components.grid.variants'),
  ],
  [grid, gridItem],
  `display: grid;`,
  {
    variant: 'default',
    __gridCommon__: 'common',
  },
);

export default Grid;
